import { useEffect } from 'react';
import './index.css'; // Add your CSS styles here

const Stars = () => {
  useEffect(() => {
    // Function to create stars
    function createStars(container, type, quantity) {
      for (let i = 0; i < quantity; i++) {
        const star = document.createElement('div');
        star.classList.add('star', `type-${type}`);
        star.style.left = `${randomNumber(1, 99)}%`;
        star.style.bottom = `${randomNumber(1, 99)}%`;
        star.style.animationDuration = `${randomNumber(50, 200)}s`;
        container.appendChild(star);
      }
    }

    // Function to generate random numbers
    function randomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // Select the container where stars should appear
    const starContainer = document.getElementById('star-container');
    if (starContainer) {
      createStars(starContainer, 1, 100);
      createStars(starContainer, 2, 85);
      createStars(starContainer, 3, 70);
    }

    // Cleanup function to remove only stars
    return () => {
      if (starContainer) {
        const stars = starContainer.querySelectorAll('.star');
        stars.forEach((star) => star.remove());
      }
    };
  }, []);

  return null; // This component doesn't render anything directly
};

export default Stars;
